import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiExternalLink, FiHome, FiLogOut, FiPlus } from 'react-icons/fi';
import { adminAPI } from '../../services/blogApi';

const AdminHeader: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname.startsWith(path);

  const handleLogout = () => {
    adminAPI.logout();
    navigate('/admin/login');
  };

  return (
    <header className="sticky top-0 z-50 border-b bg-slate-900 text-white border-slate-700">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          <div className="flex items-center gap-6">
            <Link to="/admin/dashboard" className="font-bold text-sm tracking-wide text-blue-300">
              travelbaba786 Admin
            </Link>
            <nav className="flex items-center gap-1">
              <Link
                to="/admin/dashboard"
                className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive('/admin/dashboard')
                    ? 'bg-slate-700 text-white'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <FiHome size={14} /> <span className="hidden sm:inline">Dashboard</span>
              </Link>
              <Link
                to="/admin/blogs/new"
                className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive('/admin/blogs')
                    ? 'bg-slate-700 text-white'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <FiPlus size={14} /> <span className="hidden sm:inline">New Post</span><span className="sm:hidden">New</span>
              </Link>
            </nav>
          </div>

          <div className="flex items-center gap-2">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold text-slate-300 hover:bg-slate-800 hover:text-white transition-colors"
            >
              <FiExternalLink size={14} /> View Site
            </a>
            <button
              type="button"
              onClick={handleLogout}
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold text-slate-300 hover:bg-red-900/40 hover:text-red-200 transition-colors"
            >
              <FiLogOut size={14} /> Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
